export const SECTION_TYPES = [
  { id: 'hero', name: 'Hero Banner', description: 'Large banner with title, subtitle and CTA' },
  { id: 'text', name: 'Text Block', description: 'Simple text content section' },
  { id: 'image', name: 'Full Image', description: 'Full-width image section' },
  { id: 'text_image', name: 'Text + Image', description: 'Text alongside an image' },
  { id: 'features', name: 'Features Grid', description: 'Grid of feature cards with icons' },
  { id: 'cta', name: 'Call to Action', description: 'Prominent call-to-action section' },
  { id: 'testimonials', name: 'Testimonials', description: 'Customer reviews and quotes' },
  { id: 'gallery', name: 'Image Gallery', description: 'Grid of images' },
  { id: 'services', name: 'Services', description: 'Display service categories' },
  { id: 'stats', name: 'Statistics', description: 'Number stats with labels' },
  { id: 'spacer', name: 'Spacer', description: 'Empty space between sections' },
  { id: 'video', name: 'Video', description: 'Embed YouTube, Vimeo, or direct video' },
  { id: 'review_form', name: 'Leave a review', description: 'Review form for customers — you approve reviews before they show' },
];

/**
 * Optional blocks an owner can add to the built-in pages (home, about,
 * services). Those pages have a fixed design, so only self-contained extras
 * are offered there; custom pages can use every SECTION_TYPES entry.
 */
export const BUILT_IN_PAGE_EXTRA_TYPES = ['review_form'] as const;

export const getDefaultContent = (sectionType: string): Record<string, unknown> => {
  switch (sectionType) {
    case 'hero':
      return {
        title: 'Your Headline Here',
        subtitle: 'Add a compelling description that tells visitors what you do.',
        ctaText: 'Get Started',
        ctaLink: '/booking',
        imageUrl: '',
      };
    case 'text':
      return {
        title: 'Section Title',
        content: 'Add your content here. You can write multiple paragraphs to explain your message.',
        alignment: 'center',
      };
    case 'image':
      return {
        imageUrl: '',
        alt: 'Image description',
        caption: '',
      };
    case 'text_image':
      return {
        title: 'Feature Title',
        content: 'Describe your feature or service in detail.',
        imageUrl: '',
        imagePosition: 'right',
      };
    case 'features':
      return {
        title: 'Our Features',
        subtitle: 'What makes us different',
        features: [
          { icon: 'Shield', title: 'Feature 1', description: 'Description of feature 1' },
          { icon: 'Clock', title: 'Feature 2', description: 'Description of feature 2' },
          { icon: 'Heart', title: 'Feature 3', description: 'Description of feature 3' },
        ],
      };
    case 'cta':
      return {
        title: 'Ready to get started?',
        subtitle: 'Join thousands of happy customers today.',
        buttonText: 'Contact Us',
        buttonLink: '/booking',
      };
    case 'testimonials':
      return {
        title: 'What Our Clients Say',
        testimonials: [
          { name: 'John D.', location: 'Cardiff', content: 'Great service!', rating: 5 },
        ],
      };
    case 'gallery':
      return {
        title: 'Gallery',
        images: [],
        columns: 3,
      };
    case 'services':
      return {
        title: 'Our Services',
        subtitle: 'Professional solutions for every need',
        showPrices: true,
      };
    case 'stats':
      return {
        stats: [
          { value: '100+', label: 'Happy Customers' },
          { value: '5', label: 'Years Experience' },
          { value: '24/7', label: 'Support' },
        ],
      };
    case 'spacer':
      return {
        height: 'medium',
      };
    case 'video':
      return {
        title: '',
        subtitle: '',
        videoUrl: '',
        autoplay: false,
        aspectRatio: '16:9',
      };
    case 'review_form':
      return {
        eyebrow: 'Reviews',
        title: 'Leave a review',
        subtitle: 'Had a clean with us recently? We would love to hear how it went.',
        buttonText: 'Submit review',
      };
    default:
      return {};
  }
};
